<template>
  <div class="w-full h-48 bg-secondary my-6 flex items-center">
    <div class="w-32">
      <router-link
        :to="{
          path: '/movies/',
          name: 'MovieDetails',
          params: {
            id: data.id
          }
        }"
      >
        <img
          :src="imageUrl(data['poster_path'])"
          :alt="data['title']"
          class="w-full h-full"
        />
      </router-link>
    </div>
    <div class="flex-1 relative w-full h-full">
      <div
        class="banner absolute top-0"
        :style="{
          backgroundImage: `url(${backdropUrl(data['backdrop_path'])})`
        }"
      />
      <div class="block absolute top-0 left-0 p-3 px-8 text-white z-20">
        <router-link
          :to="{
            path: '/movies/',
            name: 'MovieDetails',
            params: {
              id: data.id
            }
          }"
        >
          <span class="text-yellow-500 block mb-2"
            ><i class="fas fa-star mr-2"></i> {{ data["vote_average"] }}</span
          >
          <h6 class="text-xl font-semibold mb-2">
            {{ data["title"] }}
            <span class="text-base"
              >({{
                getYear(data["release_date"] || data["first_air_date"])
              }})</span
            >
          </h6>
          <p class="text-gray-200">
            {{
              data["overview"].length > 200
                ? data["overview"].slice(0, 200) + "..."
                : data["overview"]
            }}
          </p>
        </router-link>
        <div class="mt-2 pb-2">
          <ul class="flex items-center">
            <li class="mr-2">
              <button-icon
                :style="'bg-gray-700'"
                :color="'text-white'"
                :tippy_content="'Add to favourite'"
                ><i class="fas fa-heart"></i
              ></button-icon>
            </li>
            <li class="mr-2">
              <button-icon
                :style="'bg-gray-700'"
                :color="'text-white'"
                :tippy_content="'Add to watchlist'"
                ><i class="fas fa-plus"></i
              ></button-icon>
            </li>
            <li>
              <button-icon
                :color="'text-white'"
                :style="'bg-gray-700'"
                :tippy_content="'Create list'"
                ><i class="fas fa-list"></i
              ></button-icon>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "card-explore-movie-list",
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.banner {
  width: 100%;
  background-position: center;
  background-size: cover;
  transition: opacity 0.25s ease 0s;
  height: 100%;
  opacity: 0.2;
}
</style>
